export const enumMessageCode = {
  余额不足: 1,
  用户会话无效: 2,
  弹出: 3,
  函数生成: 4,
  答复超长: 5,
};

export const enumCallType = {
  WebSocket: 0,
  HTTP: 1,
};
